// extracted by mini-css-extract-plugin
export default {"errorContainer":"markets__errorContainer__fvukBT","fadeIn":"markets__fadeIn__V3HRf7","errorHeading":"markets__errorHeading__SlpdaM"};